export default "__VITE_ASSET__DHzWqpIj__"